module.exports = __webpack_public_path__ + "img/icon-shop-blue.16e6bd39.svg";